  const SEARCHANISE_DEFAULT_SORT = {
      sortBy: null,
      sortOrder: null,
    };

  function getManualCollectionSortBy() {
    return window.collectionID ? "collection_" + window.collectionID + "_position" : null;
  }

  function getSortStateFromOption(option) {
    const valueSortBy = option?.getAttribute("data-value"),
      sortOrder =
        option?.getAttribute("data-sortorder") ||
        option?.getAttribute("data-sortOrder") ||
        "asc";

    if (!valueSortBy || valueSortBy === "manual") {
      return {
        sortBy: getManualCollectionSortBy(),
        sortOrder: null,
      };
    }

    return {
      sortBy: valueSortBy,
      sortOrder,
    };
  }

  let initialStateFilter = {
      availabilityCollection: [],
      finishCollection: [],
      framematerialCollection: [],
      frameColorCollection: [],
      lensColorCollection: [],
      frameWidth: [],
      bridgeWidth: [],
      templeWidth: [],
      lensWidth: [],
      lensHeight: [],
      lensTransmission: [],
      frameSizeCollection: [],
      lensTintCollection: [],
      loading: !1,
      page: 1,
      maxResults: 20,
      totalItems: 20,
      sortBy: getManualCollectionSortBy(),
      sortOrder: SEARCHANISE_DEFAULT_SORT.sortOrder,
      frameWidthChanged: !1,
      bridgeWidthChanged: !1,
      templeWidthChanged: !1,
      lensWidthChanged: !1,
      lensHeightChanged: !1,
      lensTransmissionChanged: !1,
      frameWidthOldValues: {
        range: { left: "", right: "" },
        thumbLeft: "",
        thumbLeftValue: "",
        thumbRight: "",
        thumbRightValue: "",
      },
      bridgeWidthOldValues: {
        range: { left: "", right: "" },
        thumbLeft: "",
        thumbLeftValue: "",
        thumbRight: "",
        thumbRightValue: "",
      },
      templeWidthOldValues: {
        range: { left: "", right: "" },
        thumbLeft: "",
        thumbLeftValue: "",
        thumbRight: "",
        thumbRightValue: "",
      },
      lensWidthOldValues: {
        range: { left: "", right: "" },
        thumbLeft: "",
        thumbLeftValue: "",
        thumbRight: "",
        thumbRightValue: "",
      },
      lensHeightOldValues: {
        range: { left: "", right: "" },
        thumbLeft: "",
        thumbLeftValue: "",
        thumbRight: "",
        thumbRightValue: "",
      },
      lensTransmissionOldValues: {
        range: { left: "", right: "" },
        thumbLeft: "",
        thumbLeftValue: "",
        thumbRight: "",
        thumbRightValue: "",
      },
      dimensionsCount: [],
      openedFacets: [],
      urlParamKeys: { "lens-color": "lens-color" },
      sortProducts: !0,
      nextScrollLoadAllowedAt: 0,
    },
    frameWidthOptions = [],
    bridgeWidthOptions = [],
    templeWidthOptions = [],
    lensWidthOptions = [],
    lensHeightOptions = [],
    lensTransmissionOptions = [],
    frameWidthFirstOptions = [],
    bridgeWidthFirstOptions = [],
    templeWidthFirstOptions = [],
    lensWidthFirstOptions = [],
    lensHeightFirstOptions = [],
    lensTransmissionFirstOptions = [];

  function extractFacetNumber(rawValue, expectedPrefix) {
    const raw = String(rawValue || "");
    const direct = parseFloat(raw.replace(expectedPrefix, ""));
    if (!isNaN(direct)) return direct;

    const fallback = raw.match(/-?\d+(\.\d+)?(?=[^\d]*$)/);
    return fallback ? parseFloat(fallback[0]) : NaN;
  }

  function facetBucketMatchesKey(rawValue, key) {
    const raw = String(rawValue || "").toLowerCase();
    return (
      raw.startsWith(`${key}-`) ||
      raw.includes(`_${key}:`) ||
      raw.includes(`_${key}:number:`)
    );
  }

  function parseNumericAttr(el, attrName) {
    const raw = el?.getAttribute(attrName);
    if (!raw) return NaN;
    const match = String(raw).match(/-?\d+(\.\d+)?/);
    return match ? parseFloat(match[0]) : NaN;
  }

  function normalizeFacetAttribute(rawAttribute) {
    return String(rawAttribute || "")
      .toLowerCase()
      .replace(/\s+/g, "")
      .replace(/-/g, "_");
  }

  function facetAttributeMatches(rawAttribute, aliases = []) {
    const normalized = normalizeFacetAttribute(rawAttribute);
    return aliases.some((alias) =>
      normalized.includes(normalizeFacetAttribute(alias)),
    );
  }

  function getFacetAttributeFromInput(input) {
    return (
      input
        ?.closest(".tab-content")
        ?.previousElementSibling?.querySelector(".tab-title")
        ?.getAttribute("data-attribute") || ""
    );
  }

  function formatFilterNumber(value, decimals = 1) {
    return Number(value)
      .toFixed(decimals)
      .replace(/(\.\d*?[1-9])0+$/, "$1")
      .replace(/\.0+$/, "");
  }

  function getSliderSelectedRange(id, decimals = 1) {
    const slider = document.getElementById(id);
    if (!slider?.noUiSlider) return null;

    const values = slider.noUiSlider
      .get()
      .map((value) => parseFloat(value))
      .filter((value) => !isNaN(value));

    if (values.length !== 2) return null;

    return values
      .sort((a, b) => a - b)
      .map((value) => Number(value.toFixed(decimals)));
  }

  function getSliderBounds(id, options = [], decimals = 1) {
    const slider = document.getElementById(id);
    let minValue = Array.isArray(options) && options.length
      ? Math.min(...options)
      : parseNumericAttr(slider, "data-min");
    let maxValue = Array.isArray(options) && options.length
      ? Math.max(...options)
      : parseNumericAttr(slider, "data-max");

    if (!isFinite(minValue) || !isFinite(maxValue)) return null;

    return [minValue, maxValue]
      .sort((a, b) => a - b)
      .map((value) => Number(value.toFixed(decimals)));
  }

  function isMeaningfulSliderRange(selectedRange, fullRange, epsilon = 0.001) {
    return (
      Math.abs(selectedRange[0] - fullRange[0]) > epsilon ||
      Math.abs(selectedRange[1] - fullRange[1]) > epsilon
    );
  }

  function applyNumericSliderFilter({
    sliderId,
    options,
    stateKey,
    tagPrefix,
    decimals = 1,
  }) {
    initialStateFilter[stateKey] = [];

    const selectedRange = getSliderSelectedRange(sliderId, decimals);
    const fullRange = getSliderBounds(sliderId, options, decimals);

    if (!selectedRange || !fullRange) return;
    if (!isMeaningfulSliderRange(selectedRange, fullRange)) return;

    const inRangeOptions = (Array.isArray(options) ? options : [])
      .filter((value) => typeof value === "number" && !isNaN(value))
      .sort((a, b) => a - b)
      .filter(
        (value) =>
          value >= selectedRange[0] - 0.001 && value <= selectedRange[1] + 0.001,
      );

    const valuesToUse = (inRangeOptions.length ? inRangeOptions : selectedRange)
      .map((value) => formatFilterNumber(value, decimals))
      .filter((value, index, arr) => arr.indexOf(value) === index);

    initialStateFilter[stateKey] = valuesToUse.map((value) => `${tagPrefix}${value}`);
  }

  const sliderDebug = !1;
  function logSliderDebug(...args) {
    if (sliderDebug) console.log(...args);
  }

  function ensureNoUiSlider(id, options, suffix = "", decimals = 1) {
    if (typeof noUiSlider === "undefined") {
      logSliderDebug("[SLIDER DEBUG] noUiSlider missing for", id);
      return !1;
    }
    const el = document.getElementById(id);
    if (!el) {
      logSliderDebug("[SLIDER DEBUG] element not found:", id);
      return !1;
    }
    if (el.noUiSlider) {
      logSliderDebug("[SLIDER DEBUG] already initialized:", id);
      return !0;
    }

    const safeOptions = Array.isArray(options)
      ? options.filter((n) => typeof n === "number" && !isNaN(n))
      : [];

    let minVal = safeOptions.length ? Math.min(...safeOptions) : parseNumericAttr(el, "data-min");
    let maxVal = safeOptions.length ? Math.max(...safeOptions) : parseNumericAttr(el, "data-max");

    if (!isFinite(minVal) || !isFinite(maxVal)) {
      logSliderDebug("[SLIDER DEBUG] invalid min/max", id, {
        safeOptionsLength: safeOptions.length,
        minVal,
        maxVal,
        dataMin: el.getAttribute("data-min"),
        dataMax: el.getAttribute("data-max"),
      });
      return !1;
    }
    if (minVal === maxVal) maxVal = minVal + 0.1;

    noUiSlider.create(el, {
      start: [minVal, maxVal],
      connect: !0,
      range: { min: minVal, max: maxVal },
      tooltips: {
        to: function (value) {
          return Number(value).toFixed(decimals) + suffix;
        },
      },
    });

    logSliderDebug("[SLIDER DEBUG] created", id, {
      minVal,
      maxVal,
      safeOptionsLength: safeOptions.length,
    });

    wireSliderEvent(id);

    return true;
  }

  function wireSliderEvent(id) {
    const el = document.getElementById(id);
    if (!el?.noUiSlider) return;

    const eventMap = {
      "frame-width-slider":       () => { initialStateFilter.frameWidthChanged = true; trackDimension("frame"); },
      "bridge-width-slider":      () => { initialStateFilter.bridgeWidthChanged = true; trackDimension("bridge"); },
      "temple-length-slider":     () => { initialStateFilter.templeWidthChanged = true; trackDimension("temple"); },
      "lens-width-slider":        () => { initialStateFilter.lensWidthChanged = true; trackDimension("lens"); },
      "lens-height-slider":       () => { initialStateFilter.lensHeightChanged = true; trackDimension("lens-height"); },
      "lens-transmission-slider": () => { initialStateFilter.lensTransmissionChanged = true; trackTransmission(); },
    };

    const handler = eventMap[id];
    if (handler) {
      el.noUiSlider.on("change", () => { handler(); applyInstantFilter(); });
    }
  }

  function trackDimension(key) {
    if (!initialStateFilter.dimensionsCount.includes(key)) {
      initialStateFilter.dimensionsCount.push(key);
    }
    const count = initialStateFilter.dimensionsCount.length;
    document.getElementById("filter-count-dimensions").innerHTML = `(${count})`;
    document.getElementById("filter-count-dimensions").classList.add("active");
    document.getElementById("clear-filter-dimensions").classList.add("active");
  }

  function trackTransmission() {
    const el = document.getElementById("filter-count-lens-transmission");
    if (el) { el.innerHTML = "(1)"; el.classList.add("active"); }
    document.getElementById("clear-filter-lens-transmission")?.classList.add("active");
  }

  function ensureSliderNodesExist() {
    const sidebarGrid = document.querySelector(".sidebar-content .is-grid");
    if (sidebarGrid && !document.getElementById("filter-facets-content-dimensions")) {
      sidebarGrid.insertAdjacentHTML(
        "beforeend",
        `
        <div class="tab-item-facet is-active" data-facet="Dimensions" style="order: 6;">
          <facet-heading>
            <div class="tab-heading-facet is-flex is-align-center is-justify-space-between">
              <p class="tab-title" data-attribute="dimensions">
                Dimensions
                <span class="filter-count" id="filter-count-dimensions"></span>
              </p>
              <span class="tab-action is-flex is-align-center">
                <span class="tab-action-clear-filter" id="clear-filter-dimensions">Clear</span>
              </span>
            </div>
          </facet-heading>
          <div class="tab-content" id="filter-facets-content-dimensions">
            <div class="multiple-slider-range"><p>Frame Width</p></div>
            <div class="multiple-slider-range"><p>Bridge Width</p></div>
            <div class="multiple-slider-range"><p>Temple Length</p></div>
            <div class="multiple-slider-range"><p>Lens Height</p></div>
            <div class="multiple-slider-range"><p>Lens Width</p></div>
          </div>
        </div>`,
      );
      logSliderDebug("[SLIDER DEBUG] injected fallback dimensions tab");
    }

    if (sidebarGrid && !document.getElementById("filter-facets-content-lens-transmission")) {
      sidebarGrid.insertAdjacentHTML(
        "beforeend",
        `
        <div class="tab-item-facet is-active" data-facet="Lens Transmission" style="order: 4;">
          <facet-heading>
            <div class="tab-heading-facet is-flex is-align-center is-justify-space-between">
              <p class="tab-title" data-attribute="lens_transmission">
                Lens Transmission
                <span class="filter-count" id="filter-count-lens-transmission"></span>
              </p>
              <span class="tab-action is-flex is-align-center">
                <span class="tab-action-clear-filter" id="clear-filter-lens-transmission">Clear</span>
              </span>
            </div>
          </facet-heading>
          <div class="tab-content" id="filter-facets-content-lens-transmission">
            <div class="multiple-slider-range"><h5>Lens Transmission</h5></div>
          </div>
        </div>`,
      );
      logSliderDebug("[SLIDER DEBUG] injected fallback lens transmission tab");
    }

    const dimensionsContainer = document.getElementById("filter-facets-content-dimensions");
    if (dimensionsContainer) {
      // FIX: use "h5, p" so both tag types are matched for all dimension rows
      const map = {
        "frame width": "frame-width-slider",
        "bridge width": "bridge-width-slider",
        "temple length": "temple-length-slider", // FIX: was "temple-width-slider"
        "lens height": "lens-height-slider",
        "lens width": "lens-width-slider",
      };

      dimensionsContainer
        .querySelectorAll(".multiple-slider-range")
        .forEach((row) => {
          const label = row.querySelector("h5, p")?.textContent?.trim()?.toLowerCase(); // FIX: was "h5" only
          const id = map[label];
          if (!id) return;
          if (!document.getElementById(id)) {
            const div = document.createElement("div");
            div.id = id;
            div.className = "noui-slider";
            row.appendChild(div);
            logSliderDebug("[SLIDER DEBUG] injected missing node", id);
          }
        });
    }

    const lensTransmissionTab = document.getElementById("filter-facets-content-lens-transmission");
    if (lensTransmissionTab && !document.getElementById("lens-transmission-slider")) {
      const row = lensTransmissionTab.querySelector(".multiple-slider-range");
      if (row) {
        const div = document.createElement("div");
        div.id = "lens-transmission-slider";
        div.className = "noui-slider";
        row.appendChild(div);
        logSliderDebug("[SLIDER DEBUG] injected missing node", "lens-transmission-slider");
      }
    }
  }

  function initDimensionAndTransmissionSliders() {
    const hasNoUi = typeof noUiSlider !== "undefined";
    if (!hasNoUi) {
      logSliderDebug("[SLIDER DEBUG] init skipped; noUiSlider undefined");
      return !1;
    }

    ensureSliderNodesExist();

    logSliderDebug("[SLIDER DEBUG] init start", {
      frameWidthOptions: frameWidthOptions.length,
      bridgeWidthOptions: bridgeWidthOptions.length,
      templeWidthOptions: templeWidthOptions.length,
      lensWidthOptions: lensWidthOptions.length,
      lensHeightOptions: lensHeightOptions.length,
      lensTransmissionOptions: lensTransmissionOptions.length,
    });

    ensureNoUiSlider("frame-width-slider", frameWidthOptions, " mm", 1);
    ensureNoUiSlider("bridge-width-slider", bridgeWidthOptions, " mm", 1);
    ensureNoUiSlider("temple-length-slider", templeWidthOptions, " mm", 1); // FIX: was "temple-width-slider"
    ensureNoUiSlider("lens-width-slider", lensWidthOptions, " mm", 1);
    ensureNoUiSlider("lens-height-slider", lensHeightOptions, " mm", 1);
    ensureNoUiSlider("lens-transmission-slider", lensTransmissionOptions, "%", 2);

    return !0;
  }

  function scheduleSliderReinit(maxAttempts = 20, delayMs = 150) {
    let attempts = 0;
    const run = () => {
      attempts += 1;
      logSliderDebug("[SLIDER DEBUG] reinit attempt", attempts, "of", maxAttempts);
      const ready = initDimensionAndTransmissionSliders();
      if (!ready && attempts < maxAttempts) setTimeout(run, delayMs);
    };
    run();
  }

  window.addEventListener("load", () => {
    scheduleSliderReinit(6, 120);
  });
  createLoadingState();
  function search(
    tags,
    price,
    page,
    regenerateFacets = !0,
    loadmore = !1,
    isFirstLoading = !1,
    populateFiltersOnly = !1,
    loadingWithParams = !1,
  ) {
    const API_URL = "https://searchserverapi1.com/getresults",
      API_KEY = "7J6C0i2U7S";
    let q = "",
      collection = window.collection;
    (console.log(tags),
      tags &&
        (tags = [
          ...tags.split(",").map((tag) => {
            if (tag) {
              const subTags = tag.split("|");
              return (
                tag +
                "|" +
                subTags
                  .map((subTag) => {
                    const value = subTag.split("-").pop(),
                      key = subTag.replace(`-${value}`, "").replaceAll("-", "_");
                    return isNaN(parseFloat(value))
                      ? `_${key}:${value}`
                      : `_${key}:number:${value}`;
                  })
                  .join("|")
              );
            } else return;
          }),
        ].join(",")),
      console.log(tags),
      (initialStateFilter.page = page));
      console.log(initialStateFilter.sortBy);
    let payload = {
      api_key: API_KEY,
      q,
      sortBy: initialStateFilter.sortBy,
      sortOrder: initialStateFilter.sortOrder,
      "restrictBy[tags]": tags,
      "restrictBy[stock_status]": "In Stock",
      "restrictBy[price]": price,
      startIndex: page == 1 ? 0 : page * 20 - 20,
      maxResults: initialStateFilter.maxResults,
      items: !0,
      pages: !0,
      categories: !0,
      suggestions: !0,
      queryCorrection: !0,
      suggestionsMaxResults: 3,
      pagesMaxResults: 200,
      categoryStartIndex: 0,
      categoriesMaxResults: 200,
      facets: !0,
      facetsShowUnavailableOptions: !1,
      ResultsTitleStrings: 3,
      ResultsDescriptionStrings: 0,
      collection,
      page,
      prepareVariantOptions: !0,
      output: "json",
    };
    if (!payload.sortBy) {
      delete payload.sortBy;
      delete payload.sortOrder;
    } else if (!payload.sortOrder) {
      delete payload.sortOrder;
    }
    (tags || delete payload["restrictBy[tags]"],
      price || delete payload["restrictBy[price]"],
      $.get(API_URL, payload).done(async (data) => {
        if (
          ((data = JSON.parse(data)),
          data.facets &&
            data.facets.length > 0 &&
            ((document.querySelector(".filter-button").style.display = "block"),
            regenerateFacets))
        )
          if (isFirstLoading) {
            document.querySelector(".sidebar-content .is-grid").innerHTML = "";
            let dimensionsHTML = "";
            const filterOrder = {
                "Lens Color": 1,
                "Frame color": 2,
                "Lens Tint": 3,
                "Lens Transmission": 4,
                Finish: 5,
                Dimensions: 6,
                "Frame Size": 7,
                "Frame Material": 8,
              },
              frameSizeFilterOrder = { xlarge: 0, large: 1, medium: 2, small: 3 };
            (data.facets.forEach((facet, index) => {
              facet.title == "Lens Color" &&
                (data.facets.splice(index, 1), data.facets.unshift(facet));
            }),
              data.facets.forEach((facet, index) => {
                let contentData = "";
                const titleLower = (facet.title || "")
                  .toLowerCase()
                  .trim()
                  .replace(/\s+/g, " ");
                const firstBucketValue =
                  facet && facet.buckets && facet.buckets[0]
                    ? String(facet.buckets[0].value || "")
                    : "";
                const isFrameWidthFacet =
                  titleLower === "frame width" ||
                  firstBucketValue.startsWith("frame_width-") ||
                  facetBucketMatchesKey(firstBucketValue, "frame_width");
                const isBridgeWidthFacet =
                  titleLower === "bridge width" ||
                  firstBucketValue.startsWith("bridge_width-") ||
                  facetBucketMatchesKey(firstBucketValue, "bridge_width");
                const isTempleLengthFacet =
                  titleLower === "temple length" ||
                  firstBucketValue.startsWith("temple_length-") ||
                  facetBucketMatchesKey(firstBucketValue, "temple_length");
                const isLensWidthFacet =
                  titleLower === "lens width" ||
                  firstBucketValue.startsWith("lens_width-") ||
                  facetBucketMatchesKey(firstBucketValue, "lens_width");
                const isLensHeightFacet =
                  titleLower === "lens height" ||
                  firstBucketValue.startsWith("lens_height-") ||
                  facetBucketMatchesKey(firstBucketValue, "lens_height");
                if (
                  isFrameWidthFacet ||
                  isBridgeWidthFacet ||
                  isTempleLengthFacet ||
                  isLensWidthFacet ||
                  isLensHeightFacet
                ) {
                  if (frameWidthOptions.length === 0 && isFrameWidthFacet) {
                    frameWidthOptions = facet.buckets
                      .map((w) => extractFacetNumber(w.value, "frame_width-"))
                      .filter((n) => !isNaN(n))
                      .sort((a, b) => a - b);
                    frameWidthFirstOptions.length === 0 &&
                      (frameWidthFirstOptions = frameWidthOptions.slice());
                  }

                  if (bridgeWidthOptions.length === 0 && isBridgeWidthFacet) {
                    bridgeWidthOptions = facet.buckets
                      .map((w) => extractFacetNumber(w.value, "bridge_width-"))
                      .filter((n) => !isNaN(n))
                      .sort((a, b) => a - b);
                    bridgeWidthFirstOptions.length === 0 &&
                      (bridgeWidthFirstOptions = bridgeWidthOptions.slice());
                  }

                  if (templeWidthOptions.length === 0 && isTempleLengthFacet) {
                    templeWidthOptions = facet.buckets
                      .map((w) => extractFacetNumber(w.value, "temple_length-"))
                      .filter((n) => !isNaN(n))
                      .sort((a, b) => a - b);
                    templeWidthFirstOptions.length === 0 &&
                      (templeWidthFirstOptions = templeWidthOptions.slice());
                  }

                  if (lensHeightOptions.length === 0 && isLensHeightFacet) {
                    lensHeightOptions = facet.buckets
                      .map((w) => extractFacetNumber(w.value, "lens_height-"))
                      .filter((n) => !isNaN(n))
                      .sort((a, b) => a - b);
                    lensHeightFirstOptions.length === 0 &&
                      (lensHeightFirstOptions = lensHeightOptions.slice());
                  }

                  if (lensWidthOptions.length === 0 && isLensWidthFacet) {
                    lensWidthOptions = facet.buckets
                      .map((w) => extractFacetNumber(w.value, "lens_width-"))
                      .filter((n) => !isNaN(n))
                      .sort((a, b) => a - b);
                    lensWidthFirstOptions.length === 0 &&
                      (lensWidthFirstOptions = lensWidthOptions.slice());
                  }

                  isFrameWidthFacet &&
                    (contentData = `
                    <div class="multiple-slider-range">
                      <p>Frame Width</p>
                      <div id="frame-width-slider" class="noui-slider"></div>
                    </div>
                  `);
                  isBridgeWidthFacet &&
                    (contentData = `
                    <div class="multiple-slider-range">
                      <p>Bridge Width</p>
                      <div id="bridge-width-slider" class="noui-slider"></div>
                    </div>
                  `);
                  isTempleLengthFacet &&
                    (contentData = `
                    <div class="multiple-slider-range">
                      <p>Temple Length</p>
                      <div id="temple-length-slider" class="noui-slider"></div>
                    </div>
                  `);
                  isLensWidthFacet &&
                    (contentData = `
                    <div class="multiple-slider-range">
                      <p>Lens Width</p>
                      <div id="lens-width-slider" class="noui-slider"></div>
                    </div>
                  `);
                  isLensHeightFacet &&
                    (contentData = `
                    <div class="multiple-slider-range">
                      <p>Lens Height</p>
                      <div id="lens-height-slider" class="noui-slider"></div>
                    </div>
                  `);
                  dimensionsHTML += contentData;
                } else if (
                  titleLower == "lens transmission" ||
                  (facet.buckets &&
                    facet.buckets.length &&
                    facet.buckets[0].value &&
                    (facet.buckets[0].value.startsWith("lens_light_trans-") ||
                      facetBucketMatchesKey(
                        facet.buckets[0].value,
                        "lens_light_trans",
                      )))
                )
                  ((facet.title = "Lens Transmission"),
                    lensTransmissionOptions.length === 0 &&
                      ((lensTransmissionOptions = facet.buckets
                        .map((w) =>
                          extractFacetNumber(w.value, "lens_light_trans-"),
                        )
                        .filter((n) => !isNaN(n))
                        .sort((a, b) => a - b)),
                      lensTransmissionFirstOptions.length === 0 &&
                        (lensTransmissionFirstOptions =
                          lensTransmissionOptions.slice())),
                    (contentData = `
                  <div class="multiple-slider-range">
                    <h5>Lens Transmission</h5>
                    <div id="lens-transmission-slider" class="noui-slider"></div>
                  </div>
                `),
                    (document.querySelector(
                      ".sidebar-content .is-grid",
                    ).innerHTML += `
                <div class="tab-item-facet ${index == 0 ? "is-active" : `${initialStateFilter.openedFacets.includes(facet.title) ? "is-active" : ""}`}" ${index} data-facet="${facet.title}" style="order: ${filterOrder[facet.title] || 10}">
                  <facet-heading>
                    <div class="tab-heading-facet is-flex is-align-center is-justify-space-between">
                      <p class="tab-title" data-attribute="${facet.attribute || "lens_transmission"}">
                        ${facet.title}
                        <span class="filter-count" id="filter-count-${facet.title.toLowerCase().replaceAll(" ", "-")}"></span>
                      </p>
                      <span class="tab-action is-flex is-align-center">
                        <span class="tab-action-clear-filter" id="clear-filter-${facet.title.toLowerCase().replaceAll(" ", "-")}">Clear</span>
                        <svg class="icon-plus" style="transform: rotate(180deg)" xmlns="http://www.w3.org/2000/svg" width="14.121" height="7.811" viewBox="0 0 14.121 7.811">
                          <path id="Path_4356" data-name="Path 4356" d="M320,947l-6-6-6,6" transform="translate(-306.939 -940.25)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                        </svg>
                        <svg class="icon-minus" xmlns="http://www.w3.org/2000/svg" width="14.121" height="7.811" viewBox="0 0 14.121 7.811">
                          <path id="Path_4356" data-name="Path 4356" d="M320,947l-6-6-6,6" transform="translate(-306.939 -940.25)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                        </svg>
                      </span>
                    </div>
                  </facet-heading>
                  <div class="tab-content" id="filter-facets-content-${facet.title.toLowerCase().replaceAll(" ", "-")}">
                    ${contentData}
                  </div>
                </div>
                `));
                else {
                  switch (facet.type) {
                    case "slider":
                      facet.buckets.forEach((f) => {
                        contentData = `
                        <div class="range_container">
                          <div class="form_control">
                            <div class="form_control_container">
                              <div class="form_control_container__time">Min Price</div>
                                <input class="form_control_container__time__input" type="number" id="fromInput" value="${f.left}" min="${f.from}" max="${f.to}">
                              </div>
                              <div class="form_control_container">
                                <div class="form_control_container__time">Max Price</div>
                                  <input class="form_control_container__time__input" type="number" id="toInput" value="${f.right}" min="${f.from}" max="${f.to}">
                                </div>
                              </div>
                              <div class="sliders_control">
                                <input id="fromSlider" type="range" value="${f.from}" min="${f.from}" max="${f.to}">
                                <input id="toSlider" type="range" value="${f.to}" min="${f.from}" max="${f.to}">
                              </div>
                          </div>
                      `;
                      });
                      break;
                    case "select":
                      if (facet.title.toLowerCase().includes("color")) {
                        contentData += `
                        <div class="is-grid gap-20 grid-4 color-wrapper">`;
                        let filterColorValue = "";
                        (facet.buckets.forEach((f) => {
                          (f.value.includes("frame-color2-") &&
                            (filterColorValue = f.value
                              .replace("frame-color2-", "")
                              .replace("/", "-")),
                            f.value.includes("lens-color2-") &&
                              (filterColorValue = f.value
                                .replace("lens-color2-", "")
                                .replace("/", "-")),
                            f.value.includes("lens-color-") &&
                              (filterColorValue = f.value
                                .replace("lens-color-", "")
                                .replace("/", "-")),
                            f.value.includes("frame-color-") &&
                              (filterColorValue = f.value
                                .replace("frame-color-", "")
                                .replace("/", "-")),
                            f.value.includes("frame-color2- ") &&
                              (filterColorValue = f.value
                                .replace("frame-color2- ", "")
                                .replace("/", "-")),
                            f.value.includes("frame-color- ") &&
                              (filterColorValue = f.value
                                .replace("frame-color- ", "")
                                .replace("/", "-")),
                            f.value.includes("frame-color-floral") ||
                              (contentData += `
                              <div class="color-item is-flex is-justify-space-between is-flex-column">
                                <input type="checkbox" id="${f.value}" data-value="${f.value}" />
                                <label for="${f.value}">
                                  <div class="filter-color-bg" style="background-image: url('${window.shopifyAssetsUrl.replace("colorImageURL", filterColorValue + ".jpg")}')"></div>
                                  <span>${filterColorValue}</span>
                                </label>
                              </div>
                            `));
                        }),
                          (contentData += `
                        </div>`));
                      } else if (facet.title.toLowerCase().includes("tint")) {
                        contentData += `
                        <div class="is-grid gap-20 grid-4 color-wrapper">`;
                        let filterColorValue = "";
                        (facet.buckets.forEach((f) => {
                          (f.value.includes("lens_tint-") &&
                            (filterColorValue = f.value
                              .replace("lens_tint-", "")
                              .replace("/", "-")),
                            (contentData += `
                            <div class="color-item is-flex is-justify-space-between is-flex-column">
                              <input type="checkbox" id="${f.value}" data-value="${f.value}" />
                              <label for="${f.value}">
                                <div class="filter-color-bg" style="background-image: url('${window.shopifyAssetsUrl.replace("colorImageURL", filterColorValue + "-tint.jpg")}')"></div>
                                <span>${filterColorValue}</span>
                              </label>
                            </div>
                          `));
                        }),
                          (contentData += `
                        </div>`));
                      } else {
                        contentData += `
                        <ul class="nav-filter-item">`;
                        let filterValue = "";
                        (facet.buckets.forEach((f) => {
                          (f.value.includes("frame-material-")
                            ? (filterValue = f.value.replace(
                                "frame-material-",
                                "",
                              ))
                            : f.value.includes("frame-material2-")
                              ? (filterValue = f.value.replace(
                                  "frame-material2-",
                                  "",
                                ))
                              : f.value.includes("_frame_material:")
                                ? (filterValue = f.value.replace(
                                    "_frame_material:",
                                    "",
                                  ))
                                : f.value.includes("finish-")
                                  ? (filterValue = f.value.replace("finish-", ""))
                                  : f.value.includes("finish2-")
                                    ? (filterValue = f.value.replace(
                                        "finish2-",
                                        "",
                                      ))
                                    : f.value.includes("frame_width-")
                                      ? (filterValue = f.value.replace(
                                          "frame_width-",
                                          "",
                                        ))
                                      : f.value.includes("frame_size-")
                                        ? (filterValue = f.value.replace(
                                            "frame_size-",
                                            "",
                                          ))
                                        : f.value.includes("lens_tint")
                                          ? (filterValue = f.value.replace(
                                              "lens_tint-",
                                              "",
                                            ))
                                          : f.value.includes("lens_light_trans-")
                                            ? (filterValue = f.value.replace(
                                                "lens_light_trans-",
                                                "",
                                              ))
                                            : (filterValue = f.value.replace(
                                                "-",
                                                " ",
                                              )),
                            (contentData += `
                            <li class="collection-container" ${f.value.includes("frame_size-") ? `style="order: ${frameSizeFilterOrder[filterValue]}"` : ""}>
                              <div class="collection-name is-flex">
                                <input type="checkbox" id="${f.value}" data-name="Size" data-value="${f.value}">
                                <label class="value-label" for="${f.value}" filter-data="${f.value}">
                                  <div>${filterValue}</div>
                                </label>
                              </div>
                            </li>
                          `));
                        }),
                          (contentData += `
                        </ul>`));
                      }
                      break;
                    default:
                      break;
                  }
                  document.querySelector(".sidebar-content .is-grid").innerHTML +=
                    `
                <div class="tab-item-facet ${index == 0 ? "is-active" : `${initialStateFilter.openedFacets.includes(facet.title) ? "is-active" : ""}`}" ${index} data-facet="${facet.title}" style="order: ${filterOrder[facet.title] || 10}">
                  <facet-heading>
                    <div class="tab-heading-facet is-flex is-align-center is-justify-space-between">
                      <p class="tab-title" data-attribute="${facet.attribute}">
                        ${facet.title}
                        <span class="filter-count" id="filter-count-${facet.title.toLowerCase().replaceAll(" ", "-")}"></span>
                      </p>
                      <span class="tab-action is-flex is-align-center">
                        <span class="tab-action-clear-filter" id="clear-filter-${facet.title.toLowerCase().replaceAll(" ", "-")}">Clear</span>
                        <svg class="icon-plus" style="transform: rotate(180deg)" xmlns="http://www.w3.org/2000/svg" width="14.121" height="7.811" viewBox="0 0 14.121 7.811">
                          <path id="Path_4356" data-name="Path 4356" d="M320,947l-6-6-6,6" transform="translate(-306.939 -940.25)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                        </svg>
                        <svg class="icon-minus" xmlns="http://www.w3.org/2000/svg" width="14.121" height="7.811" viewBox="0 0 14.121 7.811">
                          <path id="Path_4356" data-name="Path 4356" d="M320,947l-6-6-6,6" transform="translate(-306.939 -940.25)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                        </svg>
                      </span>
                    </div>
                  </facet-heading>
                  <div class="tab-content" id="filter-facets-content-${facet.title.toLowerCase().replaceAll(" ", "-")}">
                    ${contentData}
                  </div>
                </div>
                `;
                }
              }),
              (document.querySelector(".sidebar-content .is-grid").innerHTML += `
              <div class="tab-item-facet ${initialStateFilter.openedFacets.includes("Dimensions") ? "is-active" : ""}" data-facet="Dimensions" style="order: 5;">
                <facet-heading>
                  <div class="tab-heading-facet is-flex is-align-center is-justify-space-between">
                    <p class="tab-title" data-attribute="dimensions">
                      Dimensions
                      <span class="filter-count" id="filter-count-dimensions">${initialStateFilter.dimensionsCount.length > 0 ? "(" + initialStateFilter.dimensionsCount.length + ")" : ""}</span>
                    </p>
                    <span class="tab-action is-flex is-align-center">
                      <span class="tab-action-clear-filter" id="clear-filter-dimensions">Clear</span>
                      <svg class="icon-plus" style="transform: rotate(180deg)" xmlns="http://www.w3.org/2000/svg" width="14.121" height="7.811" viewBox="0 0 14.121 7.811">
                        <path id="Path_4356" data-name="Path 4356" d="M320,947l-6-6-6,6" transform="translate(-306.939 -940.25)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                      </svg>
                      <svg class="icon-minus" xmlns="http://www.w3.org/2000/svg" width="14.121" height="7.811" viewBox="0 0 14.121 7.811">
                        <path id="Path_4356" data-name="Path 4356" d="M320,947l-6-6-6,6" transform="translate(-306.939 -940.25)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                      </svg>
                    </span>
                  </div>
                </facet-heading>
                <div class="tab-content" id="filter-facets-content-dimensions">
                  ${dimensionsHTML}
                </div>
              </div>
            `));
            initDimensionAndTransmissionSliders();
          } else {
            console.log("data: ", data.facets);
            let buckets = [];
            ($(".tab-content .nav-filter-item li").removeClass("disabled"),
              data.facets.forEach((facet, index) => {
                facet.title.indexOf("Color") === -1 &&
                  (buckets = [
                    ...buckets,
                    ...facet.buckets.map((bucket) => bucket.value),
                  ]);
              }),
              console.log("buckets: ", buckets),
              $(".tab-content .nav-filter-item li").each(function (index) {
                const value = $(this).find("input").data("value");
                buckets.indexOf(value) === -1 && $(this).addClass("disabled");
              }));
          }
        if (
          (console.log("products: ", data.items),
          populateFiltersOnly || showProducts(data.items, loadmore),
          handleFilterCheckUncheck(isFirstLoading),
          checkSelectedOptions(),
          (document.getElementById("result-number").innerHTML =
            data.totalItems + " items"),
          document.querySelector(".description-container") &&
            (document.querySelector(".description-container").style.display =
              "flex"),
          (initialStateFilter.totalItems = data.totalItems),
          isFirstLoading)
        ) {
          document
            .querySelectorAll(".sidebar-content .is-grid input")
            .forEach((input) => {
              input.addEventListener("change", (e) => {
                if (
                  (applyInstantFilter(),
                  e?.target && e.target.getAttribute("data-value"))
                ) {
                  const dataValue = e.target.getAttribute("data-value"),
                    [key, value] = splitAtLastDash(dataValue);
                  key &&
                    value &&
                    Object.values(initialStateFilter.urlParamKeys).includes(
                      key,
                    ) &&
                    (e.target.checked
                      ? replaceUrlParam(key, value)
                      : replaceUrlParam(key, value, !0));
                }
              });
            });
          var frameWidthSlider = document.getElementById("frame-width-slider");
          frameWidthSlider?.noUiSlider?.on("change.one", function () {
            ((initialStateFilter.frameWidthChanged = !0),
              initialStateFilter.dimensionsCount.includes("frame") ||
                (initialStateFilter.dimensionsCount.push("frame"),
                initialStateFilter.dimensionsCount.length > 0
                  ? (document
                      .getElementById("filter-count-dimensions")
                      .classList.add("active"),
                    (document.getElementById(
                      "filter-count-dimensions",
                    ).innerHTML =
                      "(" + initialStateFilter.dimensionsCount.length + ")"),
                    document
                      .getElementById("clear-filter-dimensions")
                      .classList.add("active"))
                  : (document
                      .getElementById("filter-count-dimensions")
                      .classList.remove("active"),
                    (document.getElementById(
                      "filter-count-dimensions",
                    ).innerHTML = ""),
                    document
                      .getElementById("clear-filter-dimensions")
                      .classList.remove("active"))),
              applyInstantFilter());
          });
          var bridgeWidthSlider = document.getElementById("bridge-width-slider");
          bridgeWidthSlider?.noUiSlider?.on("change.one", function () {
            ((initialStateFilter.bridgeWidthChanged = !0),
              initialStateFilter.dimensionsCount.includes("bridge") ||
                (initialStateFilter.dimensionsCount.push("bridge"),
                initialStateFilter.dimensionsCount.length > 0
                  ? (document
                      .getElementById("filter-count-dimensions")
                      .classList.add("active"),
                    (document.getElementById(
                      "filter-count-dimensions",
                    ).innerHTML =
                      "(" + initialStateFilter.dimensionsCount.length + ")"),
                    document
                      .getElementById("clear-filter-dimensions")
                      .classList.add("active"))
                  : (document
                      .getElementById("filter-count-dimensions")
                      .classList.remove("active"),
                    (document.getElementById(
                      "filter-count-dimensions",
                    ).innerHTML = ""),
                    document
                      .getElementById("clear-filter-dimensions")
                      .classList.remove("active"))),
              applyInstantFilter());
          });
          var templeWidthSlider = document.getElementById("temple-length-slider"); // FIX: was "temple-width-slider"
          templeWidthSlider?.noUiSlider?.on("change.one", function () {
            ((initialStateFilter.templeWidthChanged = !0),
              initialStateFilter.dimensionsCount.includes("temple") ||
                (initialStateFilter.dimensionsCount.push("temple"),
                initialStateFilter.dimensionsCount.length > 0
                  ? (document
                      .getElementById("filter-count-dimensions")
                      .classList.add("active"),
                    (document.getElementById(
                      "filter-count-dimensions",
                    ).innerHTML =
                      "(" + initialStateFilter.dimensionsCount.length + ")"),
                    document
                      .getElementById("clear-filter-dimensions")
                      .classList.add("active"))
                  : (document
                      .getElementById("filter-count-dimensions")
                      .classList.remove("active"),
                    (document.getElementById(
                      "filter-count-dimensions",
                    ).innerHTML = ""),
                    document
                      .getElementById("clear-filter-dimensions")
                      .classList.remove("active"))),
              applyInstantFilter());
          });
          var lensHeightSlider = document.getElementById("lens-height-slider");
          lensHeightSlider?.noUiSlider?.on("change.one", function () {
            ((initialStateFilter.lensHeightChanged = !0),
              initialStateFilter.dimensionsCount.includes("lens-height") ||
                (initialStateFilter.dimensionsCount.push("lens-height"),
                initialStateFilter.dimensionsCount.length > 0
                  ? (document
                      .getElementById("filter-count-dimensions")
                      .classList.add("active"),
                    (document.getElementById(
                      "filter-count-dimensions",
                    ).innerHTML =
                      "(" + initialStateFilter.dimensionsCount.length + ")"),
                    document
                      .getElementById("clear-filter-dimensions")
                      .classList.add("active"))
                  : (document
                      .getElementById("filter-count-dimensions")
                      .classList.remove("active"),
                    (document.getElementById(
                      "filter-count-dimensions",
                    ).innerHTML = ""),
                    document
                      .getElementById("clear-filter-dimensions")
                      .classList.remove("active"))),
              applyInstantFilter());
          });
          var lensWidthSlider = document.getElementById("lens-width-slider");
          lensWidthSlider?.noUiSlider?.on("change.one", function () {
            ((initialStateFilter.lensWidthChanged = !0),
              initialStateFilter.dimensionsCount.includes("lens") ||
                (initialStateFilter.dimensionsCount.push("lens"),
                initialStateFilter.dimensionsCount.length > 0
                  ? (document
                      .getElementById("filter-count-dimensions")
                      .classList.add("active"),
                    (document.getElementById(
                      "filter-count-dimensions",
                    ).innerHTML =
                      "(" + initialStateFilter.dimensionsCount.length + ")"),
                    document
                      .getElementById("clear-filter-dimensions")
                      .classList.add("active"))
                  : (document
                      .getElementById("filter-count-dimensions")
                      .classList.remove("active"),
                    (document.getElementById(
                      "filter-count-dimensions",
                    ).innerHTML = ""),
                    document
                      .getElementById("clear-filter-dimensions")
                      .classList.remove("active"))),
              applyInstantFilter());
          });
          var lensTransmissionSlider = document.getElementById(
            "lens-transmission-slider",
          );
          lensTransmissionSlider?.noUiSlider?.on("change.one", function () {
            ((initialStateFilter.lensTransmissionChanged = !0),
              document.getElementById("clear-filter-lens-transmission") &&
                document
                  .getElementById("clear-filter-lens-transmission")
                  .classList.add("active"),
              document.getElementById("filter-count-lens-transmission") &&
                ((document.getElementById(
                  "filter-count-lens-transmission",
                ).innerHTML = "(1)"),
                document
                  .getElementById("filter-count-lens-transmission")
                  .classList.add("active")),
              applyInstantFilter());
          });
        }
        (loadingWithParams && applyInstantFilter(!0),
          document.querySelectorAll(".collection-product-card.active").length ===
          0
            ? (document
                .querySelector(".no-results-wrapper")
                .classList.remove("hidden"),
              document
                .querySelector(".container.description-container")
                .classList.add("hidden"))
            : (document
                .querySelector(".no-results-wrapper")
                .classList.add("hidden"),
              document
                .querySelector(".container.description-container")
                .classList.remove("hidden")));
      }));
  }
  const qParam = new URLSearchParams(window.location.search),
    lensColorQuery = qParam.get("lens-color")?.toLowerCase();
  lensColorQuery &&
    lensColorQuery.split(",").forEach((q) =>
      initialStateFilter.lensColorCollection.push(
        `lens-color-${q.toLowerCase().trim()}`,
      ),
    );
  const initialTags = lensColorQuery ? initialStateFilter.lensColorCollection.join("|") : null;
  search(initialTags, null, initialStateFilter.page, !0, !1, !0, !1, !!initialTags);
  scheduleSliderReinit(6, 120);
  function checkSelectedOptions() {
    (document
      .querySelectorAll(".tab-item-facet .nav-filter-item input")
      .forEach((item) => {
        (initialStateFilter.availabilityCollection.forEach((xx) => {
          item.getAttribute("data-value") == xx && (item.checked = !0);
        }),
          initialStateFilter.framematerialCollection.forEach((xx) => {
            item.getAttribute("data-value") == xx && (item.checked = !0);
          }),
          initialStateFilter.finishCollection.forEach((xx) => {
            item.getAttribute("data-value") == xx && (item.checked = !0);
          }),
          initialStateFilter.frameSizeCollection.forEach((xx) => {
            item.getAttribute("data-value") == xx && (item.checked = !0);
          }),
          initialStateFilter.lensTintCollection.forEach((xx) => {
            item.getAttribute("data-value") == xx && (item.checked = !0);
          }));
      }),
      document
        .querySelectorAll(".color-wrapper .color-item input")
        .forEach((item) => {
          (initialStateFilter.frameColorCollection.forEach((xx) => {
            item.getAttribute("data-value") == xx && (item.checked = !0);
          }),
            initialStateFilter.lensColorCollection.forEach((xx) => {
              item.getAttribute("data-value") == xx && (item.checked = !0);
            }),
            initialStateFilter.lensTintCollection.forEach((xx) => {
              item.getAttribute("data-value") == xx && (item.checked = !0);
            }));
        }),
      initialStateFilter.frameColorCollection.length > 0 &&
        (document.getElementById("clear-filter-frame-color") &&
          document
            .getElementById("clear-filter-frame-color")
            .classList.add("active"),
        document.getElementById("filter-count-frame-color") &&
          ((document.getElementById("filter-count-frame-color").innerHTML =
            `(${initialStateFilter.frameColorCollection.filter((item) => item.toLowerCase().includes("frame")).length})`),
          document
            .getElementById("filter-count-frame-color")
            .classList.add("active"))),
      initialStateFilter.lensColorCollection.length > 0 &&
        (document.getElementById("clear-filter-lens-color") &&
          document
            .getElementById("clear-filter-lens-color")
            .classList.add("active"),
        document.getElementById("filter-count-lens-color") &&
          ((document.getElementById("filter-count-lens-color").innerHTML =
            `(${initialStateFilter.lensColorCollection.length})`),
          document
            .getElementById("filter-count-lens-color")
            .classList.add("active"))),
      initialStateFilter.finishCollection.length > 0 &&
        (document.getElementById("clear-filter-finish") &&
          document.getElementById("clear-filter-finish").classList.add("active"),
        document.getElementById("filter-count-finish") &&
          ((document.getElementById("filter-count-finish").innerHTML =
            `(${initialStateFilter.finishCollection.length})`),
          document
            .getElementById("filter-count-finish")
            .classList.add("active"))),
      initialStateFilter.framematerialCollection.length > 0 &&
        (document.getElementById("clear-filter-frame-material") &&
          document
            .getElementById("clear-filter-frame-material")
            .classList.add("active"),
        document.getElementById("filter-count-frame-material") &&
          ((document.getElementById("filter-count-frame-material").innerHTML =
            `(${initialStateFilter.framematerialCollection.length})`),
          document
            .getElementById("filter-count-frame-material")
            .classList.add("active"))),
      initialStateFilter.frameSizeCollection.length > 0 &&
        (document.getElementById("clear-filter-frame-size") &&
          document
            .getElementById("clear-filter-frame-size")
            .classList.add("active"),
        document.getElementById("filter-count-frame-size") &&
          ((document.getElementById("filter-count-frame-size").innerHTML =
            `(${initialStateFilter.frameSizeCollection.length})`),
          document
            .getElementById("filter-count-frame-size")
            .classList.add("active"))),
      initialStateFilter.lensTintCollection.length > 0 &&
        (document.getElementById("clear-filter-lens-tint") &&
          document
            .getElementById("clear-filter-lens-tint")
            .classList.add("active"),
        document.getElementById("filter-count-lens-tint") &&
          ((document.getElementById("filter-count-lens-tint").innerHTML =
            `(${initialStateFilter.lensTintCollection.length})`),
          document
            .getElementById("filter-count-lens-tint")
            .classList.add("active"))),
      initialStateFilter.lensTransmission.length > 0 &&
        (document.getElementById("clear-filter-lens-transmission") &&
          document
            .getElementById("clear-filter-lens-transmission")
            .classList.add("active"),
        document.getElementById("filter-count-lens-transmission") &&
          ((document.getElementById("filter-count-lens-transmission").innerHTML =
            "(1)"),
          document
            .getElementById("filter-count-lens-transmission")
            .classList.add("active"))),
      initialStateFilter.frameWidth.length > 0 &&
        (document
          .getElementById("clear-filter-dimensions")
          .classList.add("active"),
        document
          .getElementById("filter-count-dimensions")
          .classList.add("active")),
      initialStateFilter.bridgeWidth.length > 0 &&
        (document
          .getElementById("clear-filter-dimensions")
          .classList.add("active"),
        document
          .getElementById("filter-count-dimensions")
          .classList.add("active")),
      initialStateFilter.templeWidth.length > 0 &&
        (document
          .getElementById("clear-filter-dimensions")
          .classList.add("active"),
        document
          .getElementById("filter-count-dimensions")
          .classList.add("active")),
      initialStateFilter.lensWidth.length > 0 &&
        (document
          .getElementById("clear-filter-dimensions")
          .classList.add("active"),
        document
          .getElementById("filter-count-dimensions")
          .classList.add("active")),
      initialStateFilter.lensHeight.length > 0 &&
        (document
          .getElementById("clear-filter-dimensions")
          .classList.add("active"),
        document
          .getElementById("filter-count-dimensions")
          .classList.add("active")));
  }
  function showProducts(products, loadmore = !1) {
    if (
      (console.log("Show Products Running"),
      $(".sidebar-content").removeClass("filtering"),
      products?.length)
    ) {
      const glassType =
        new URL(window.location.href).searchParams.get("type") == "sunglasses"
          ? "sun"
          : "eye";
      let containerProducts = document.querySelector(
        ".container.collection-matrix",
      );
      ((containerProducts.style.display = "flex"),
        loadmore && containerProducts.classList.remove("no-results"));
      const allProductCards = document.querySelectorAll(
          ".collection-product-card",
        ),
        productIds = products.map((product) => product.product_id);
      if (allProductCards.length)
        for (const productCard of allProductCards) {
          let id = productCard.getAttribute("product_id");
          productIds.indexOf(id) > -1
            ? (productCard.classList.add("active"),
              initialStateFilter.sortProducts
                ? (productCard.style.order =
                    1 +
                    productIds.indexOf(id) +
                    (initialStateFilter.page - 1) * initialStateFilter.maxResults)
                : (productCard.style.order = 0),
              productCard.querySelector(".multiple-items") &&
                setTimeout(() => {
                  (new Flickity(productCard.querySelector(".multiple-items"), {
                    cellAlign: "left",
                    pageDots: !1,
                    groupCells: 3,
                    contain: !0,
                    freeScroll: !0,
                    wrapAround: !1,
                  }),
                    window.dispatchEvent(new Event("resize")));
                }, 150))
            : loadmore ||
              (productCard.classList.remove("active"),
              (productCard.style.order = ""));
        }
    } else $(".collection-product-card").removeClass("active");
    ((document.getElementById("filter-loading").style.display = "none"),
      (initialStateFilter.loading = !1));
  }
  (setTimeout(() => {
    const selectedFilters = document.getElementById("selected-filters");
    (document.getElementById("fromInput") &&
      (initialStateFilter.minPrice = document.getElementById("fromInput").value),
      document.getElementById("toInput") &&
        (initialStateFilter.maxPrice = document.getElementById("toInput").value));
    const filterButton = document.querySelector(
        ".apply-button-wrapper .action_button",
      ),
      resetFilters = document.getElementById("reset-function");
    (filterButton &&
      filterButton.addEventListener("click", () => {
        closeFilterSideBar();
      }),
      resetFilters &&
        resetFilters.addEventListener("click", (e) => {
          (e.preventDefault(),
            document
              .querySelector(".container.collection-matrix")
              .classList.remove("no-results"),
            (initialStateFilter.availabilityCollection = []),
            (initialStateFilter.finishCollection = []),
            (initialStateFilter.frameColorCollection = []),
            (initialStateFilter.lensColorCollection = []),
            (initialStateFilter.framematerialCollection = []),
            (initialStateFilter.frameSizeCollection = []),
            (initialStateFilter.lensTintCollection = []),
            (initialStateFilter.lensTransmission = []),
            (initialStateFilter.frameWidth = []),
            (initialStateFilter.bridgeWidth = []),
            (initialStateFilter.templeWidth = []),
            (initialStateFilter.lensWidth = []),
            (initialStateFilter.lensHeight = []),
            (initialStateFilter.lensTransmission = []),
            (initialStateFilter.frameWidthChanged = !1),
            (initialStateFilter.bridgeWidthChanged = !1),
            (initialStateFilter.templeWidthChanged = !1),
            (initialStateFilter.lensWidthChanged = !1),
            (initialStateFilter.lensHeightChanged = !1),
            (initialStateFilter.lensTransmissionChanged = !1),
            (initialStateFilter.dimensionsCount = []),
            document
              .getElementById("filter-result-flex")
              .classList.remove("active"),
            (selectedFilters.innerHTML = ""),
            Object.values(initialStateFilter.urlParamKeys).forEach((k) => {
              replaceUrlParam(k, "", !0);
            }),
            search(null, null, 1, !0, !1, !0));
        }));
    const sortByOptions = document.querySelectorAll(".list-of-option li");
    sortByOptions.forEach((sortByOption) => {
      sortByOption.addEventListener("click", (e) => {
        (e.preventDefault(), e.stopPropagation());
        const sortState = getSortStateFromOption(sortByOption);
        ((initialStateFilter.sortBy = sortState.sortBy),
          (initialStateFilter.sortOrder = sortState.sortOrder),
          sortByOptions.forEach((item) => {
            item.classList.remove("selected");
          }),
          sortByOption.classList.add("selected"),
          (document.querySelector("#selected-option span").innerHTML =
            '<span class="sort-by-text">Sort by:</span> ' +
            sortByOption.textContent),
          console.log(
            "filter-has-border",
            document.querySelector(".filter-has-border"),
          ),
          document.querySelector(".filter-has-border").classList.remove("active"),
          applyFilter(!0, initialStateFilter.page));
      });
    });
  }, 250),
    $(window).scroll(() => {
      const now = Date.now();
      const preloadOffset = 900;
      const nearBottom =
        window.scrollY + window.innerHeight >=
        document.documentElement.scrollHeight - preloadOffset;
      const hasMore =
        initialStateFilter.totalItems > 0 &&
        initialStateFilter.maxResults * initialStateFilter.page <
          initialStateFilter.totalItems;

      if (
        nearBottom &&
        hasMore &&
        !initialStateFilter.loading &&
        now >= initialStateFilter.nextScrollLoadAllowedAt
      ) {
        initialStateFilter.loading = !0;
        initialStateFilter.nextScrollLoadAllowedAt = now + 700;
        initialStateFilter.page++;
        applyFilter(!0, initialStateFilter.page, !0, !1);
      }
    }));
  function handleFilterCheckUncheck(isFirstLoading = !1) {
    console.log("Assigning clear buttons", isFirstLoading);
    const filterButton = document.querySelector(
        ".apply-button-wrapper .action_button",
      ),
      allCollections = document.querySelectorAll(
        ".nav-filter-item li input[type=checkbox]",
      ),
      colorsFilters = document.querySelectorAll(
        ".color-wrapper .color-item input[type=checkbox]",
      ),
      clearFrameColors = document.getElementById("clear-filter-frame-color"),
      clearLensColors = document.getElementById("clear-filter-lens-color"),
      clearFinish = document.getElementById("clear-filter-finish"),
      clearFrameSize = document.getElementById("clear-filter-frame-size"),
      clearLensTint = document.getElementById("clear-filter-lens-tint"),
      clearLensTransmission = document.getElementById(
        "clear-filter-lens-transmission",
      ),
      clearFrameMaterial = document.getElementById("clear-filter-frame-material"),
      clearDimensions = document.getElementById("clear-filter-dimensions");
    (clearFrameColors &&
      clearFrameColors.addEventListener("click", () => {
        (clearFrameColors.classList.remove("active"),
          (document.getElementById("filter-count-frame-color").innerHTML = ""),
          document
            .getElementById("filter-count-frame-color")
            .classList.remove("active"),
          (initialStateFilter.frameColorCollection = []),
          document
            .querySelectorAll(
              "#filter-facets-content-frame-color .color-item input",
            )
            .forEach((item) => {
              (item.checked &&
                document.querySelector(
                  `.selected-filter[data-value="${item.id}"]`,
                ) &&
                document
                  .querySelector(`.selected-filter[data-value="${item.id}"]`)
                  .remove(),
                (item.checked = !1));
            }),
          document.querySelectorAll(".selected-filter").length == 0 &&
            $("#filter-result-flex").removeClass("active"),
          applyInstantFilter());
      }),
      clearLensColors &&
        clearLensColors.addEventListener("click", () => {
          (clearLensColors.classList.remove("active"),
            (document.getElementById("filter-count-lens-color").innerHTML = ""),
            document
              .getElementById("filter-count-lens-color")
              .classList.remove("active"),
            (initialStateFilter.lensColorCollection = []),
            document
              .querySelectorAll(
                "#filter-facets-content-lens-color .color-item input",
              )
              .forEach((item) => {
                (item.checked &&
                  document.querySelector(
                    `.selected-filter[data-value="${item.id}"]`,
                  ) &&
                  document
                    .querySelector(`.selected-filter[data-value="${item.id}"]`)
                    .remove(),
                  (item.checked = !1));
              }),
            document.querySelectorAll(".selected-filter").length == 0 &&
              $("#filter-result-flex").removeClass("active"),
            applyInstantFilter(),
            replaceUrlParam(initialStateFilter.urlParamKeys["lens-color"], ""));
        }),
      clearFinish &&
        clearFinish.addEventListener("click", () => {
          (clearFinish.classList.remove("active"),
            (initialStateFilter.finishCollection = []),
            (document.getElementById("filter-count-finish").innerHTML =
              `(${initialStateFilter.finishCollection.length})`),
            document
              .getElementById("filter-count-finish")
              .classList.remove("active"),
            document
              .querySelectorAll(
                "#filter-facets-content-finish .nav-filter-item li input[type=checkbox]",
              )
              .forEach((item) => {
                item.checked = !1;
              }),
            document
              .querySelectorAll(
                '.selected-filter[data-target="finishCollection"]',
              )
              .forEach((el) => el.remove()),
            document.querySelectorAll(".selected-filter").length == 0 &&
              $("#filter-result-flex").removeClass("active"),
            applyInstantFilter());
        }),
      clearFrameSize &&
        clearFrameSize.addEventListener("click", () => {
          (clearFrameSize.classList.remove("active"),
            (initialStateFilter.frameSizeCollection = []),
            (document.getElementById("filter-count-frame-size").innerHTML =
              `(${initialStateFilter.frameSizeCollection.length})`),
            document
              .getElementById("filter-count-frame-size")
              .classList.remove("active"),
            document
              .querySelectorAll(
                "#filter-facets-content-frame-size .nav-filter-item li input[type=checkbox]",
              )
              .forEach((item) => {
                item.checked = !1;
              }),
            document
              .querySelectorAll(
                '.selected-filter[data-target="frameSizeCollection"]',
              )
              .forEach((el) => el.remove()),
            document.querySelectorAll(".selected-filter").length == 0 &&
              $("#filter-result-flex").removeClass("active"),
            applyInstantFilter());
        }),
      clearLensTint &&
        clearLensTint.addEventListener("click", () => {
          (clearLensTint.classList.remove("active"),
            (initialStateFilter.lensTintCollection = []),
            (document.getElementById("filter-count-lens-tint").innerHTML = ""),
            document
              .getElementById("filter-count-lens-tint")
              .classList.remove("active"),
            (initialStateFilter.lensTintCollection = []),
            document
              .querySelectorAll(
                "#filter-facets-content-lens-tint .color-item input",
              )
              .forEach((item) => {
                (item.checked &&
                  document.querySelector(
                    `.selected-filter[data-value="${item.id}"]`,
                  ) &&
                  document
                    .querySelector(`.selected-filter[data-value="${item.id}"]`)
                    .remove(),
                  (item.checked = !1));
              }),
            document.querySelectorAll(".selected-filter").length == 0 &&
              $("#filter-result-flex").removeClass("active"),
            applyInstantFilter());
        }),
      clearLensTransmission &&
        clearLensTransmission.addEventListener("click", () => {
          (clearLensTransmission.classList.remove("active"),
            (initialStateFilter.lensTransmission = []),
            (initialStateFilter.lensTransmissionChanged = !1),
            document.getElementById("filter-count-lens-transmission") &&
              ((document.getElementById(
                "filter-count-lens-transmission",
              ).innerHTML = ""),
              document
                .getElementById("filter-count-lens-transmission")
                .classList.remove("active")));
          var lensTransmissionSlider = document.getElementById(
            "lens-transmission-slider",
          );
          (lensTransmissionSlider &&
            lensTransmissionSlider.noUiSlider &&
            lensTransmissionOptions.length > 0 &&
            lensTransmissionSlider.noUiSlider.reset(),
            document
              .querySelectorAll(
                '.selected-filter[data-target="lensTransmission"]',
              )
              .forEach((el) => el.remove()),
            document.querySelectorAll(".selected-filter").length == 0 &&
              $("#filter-result-flex").removeClass("active"),
            applyInstantFilter());
        }),
      clearFrameMaterial &&
        clearFrameMaterial.addEventListener("click", () => {
          (clearFrameMaterial.classList.remove("active"),
            (initialStateFilter.framematerialCollection = []),
            (document.getElementById("filter-count-frame-material").innerHTML =
              `(${initialStateFilter.framematerialCollection.length})`),
            document
              .getElementById("filter-count-frame-material")
              .classList.remove("active"),
            document
              .querySelectorAll(
                "#filter-facets-content-frame-material .nav-filter-item li input[type=checkbox]",
              )
              .forEach((item) => {
                item.checked = !1;
              }),
            document
              .querySelectorAll(
                '.selected-filter[data-target="framematerialCollection"]',
              )
              .forEach((el) => el.remove()),
            document.querySelectorAll(".selected-filter").length == 0 &&
              $("#filter-result-flex").removeClass("active"),
            applyInstantFilter());
        }),
      isFirstLoading &&
        (colorsFilters.forEach((color) => {
          color.addEventListener("change", (e) => {
            (e.target.checked == !0
              ? e.target.getAttribute("data-value").toLowerCase().includes("tint")
                ? initialStateFilter.lensTintCollection.push(
                    e.target.getAttribute("data-value"),
                  )
                : e.target
                      .getAttribute("data-value")
                      .toLowerCase()
                      .includes("lens")
                  ? initialStateFilter.lensColorCollection.push(
                      e.target.getAttribute("data-value"),
                    )
                  : initialStateFilter.frameColorCollection.push(
                      e.target.getAttribute("data-value"),
                    )
              : e.target.getAttribute("data-value").toLowerCase().includes("tint")
                ? initialStateFilter.lensTintCollection.splice(
                    initialStateFilter.lensTintCollection.indexOf(
                      e.target.getAttribute("data-value"),
                    ),
                    1,
                  )
                : e.target
                      .getAttribute("data-value")
                      .toLowerCase()
                      .includes("lens")
                  ? initialStateFilter.lensColorCollection.splice(
                      initialStateFilter.lensColorCollection.indexOf(
                        e.target.getAttribute("data-value"),
                      ),
                      1,
                    )
                  : initialStateFilter.frameColorCollection.splice(
                      initialStateFilter.frameColorCollection.indexOf(
                        e.target.getAttribute("data-value"),
                      ),
                      1,
                    ),
              initialStateFilter.lensColorCollection.length > 0
                ? (clearLensColors.classList.add("active"),
                  (document.getElementById("filter-count-lens-color").innerHTML =
                    `(${initialStateFilter.lensColorCollection.length})`),
                  document
                    .getElementById("filter-count-lens-color")
                    .classList.add("active"))
                : (clearLensColors.classList.remove("active"),
                  document
                    .getElementById("filter-count-lens-color")
                    .classList.remove("active")),
              initialStateFilter.frameColorCollection.length > 0
                ? (clearFrameColors.classList.add("active"),
                  (document.getElementById("filter-count-frame-color").innerHTML =
                    `(${initialStateFilter.frameColorCollection.length})`),
                  document
                    .getElementById("filter-count-frame-color")
                    .classList.add("active"))
                : (clearFrameColors.classList.remove("active"),
                  document
                    .getElementById("filter-count-frame-color")
                    .classList.remove("active")),
              initialStateFilter.lensTintCollection.length > 0
                ? (clearLensTint.classList.add("active"),
                  (document.getElementById("filter-count-lens-tint").innerHTML =
                    `(${initialStateFilter.lensTintCollection.length})`),
                  document
                    .getElementById("filter-count-lens-tint")
                    .classList.add("active"))
                : (clearLensTint.classList.remove("active"),
                  document
                    .getElementById("filter-count-lens-tint")
                    .classList.remove("active")));
          });
        }),
        allCollections.forEach((item) => {
          item.addEventListener("change", (e) => {
            const dataValue = e.target.getAttribute("data-value");
            const facetAttribute = getFacetAttributeFromInput(e.target);
            const toggleCollectionValue = (collectionKey) => {
              const collection = initialStateFilter[collectionKey];
              if (e.target.checked) {
                collection.includes(dataValue) || collection.push(dataValue);
              } else {
                const index = collection.indexOf(dataValue);
                index > -1 && collection.splice(index, 1);
              }
            };

            if (facetAttributeMatches(facetAttribute, ["stock_status"])) {
              toggleCollectionValue("availabilityCollection");
              return;
            }

            if (facetAttributeMatches(facetAttribute, ["snize_facet3", "finish"])) {
              toggleCollectionValue("finishCollection");
              initialStateFilter.finishCollection.length > 0
                ? (clearFinish.classList.add("active"),
                  (document.getElementById("filter-count-finish").innerHTML =
                    `(${initialStateFilter.finishCollection.length})`),
                  document
                    .getElementById("filter-count-finish")
                    .classList.add("active"))
                : (clearFinish.classList.remove("active"),
                  (document.getElementById("filter-count-finish").innerHTML = ""),
                  document
                    .getElementById("filter-count-finish")
                    .classList.remove("active"));
              return;
            }

            if (
              facetAttributeMatches(facetAttribute, ["snize_facet13", "frame_size"])
            ) {
              toggleCollectionValue("frameSizeCollection");
              initialStateFilter.frameSizeCollection.length > 0
                ? (clearFrameSize.classList.add("active"),
                  (document.getElementById("filter-count-frame-size").innerHTML =
                    `(${initialStateFilter.frameSizeCollection.length})`),
                  document
                    .getElementById("filter-count-frame-size")
                    .classList.add("active"))
                : (clearFrameSize.classList.remove("active"),
                  (document.getElementById("filter-count-frame-size").innerHTML =
                    ""),
                  document
                    .getElementById("filter-count-frame-size")
                    .classList.remove("active"));
              return;
            }

            if (
              facetAttributeMatches(facetAttribute, ["snize_facet15", "lens_tint"])
            ) {
              toggleCollectionValue("lensTintCollection");
              initialStateFilter.lensTintCollection.length > 0
                ? (clearLensTint.classList.add("active"),
                  (document.getElementById("filter-count-lens-tint").innerHTML =
                    `(${initialStateFilter.lensTintCollection.length})`),
                  document
                    .getElementById("filter-count-lens-tint")
                    .classList.add("active"))
                : (clearLensTint.classList.remove("active"),
                  (document.getElementById("filter-count-lens-tint").innerHTML =
                    ""),
                  document
                    .getElementById("filter-count-lens-tint")
                    .classList.remove("active"));
              return;
            }

            if (
              facetAttributeMatches(facetAttribute, [
                "snize_facet4",
                "frame_material",
              ])
            ) {
              toggleCollectionValue("framematerialCollection");
              initialStateFilter.framematerialCollection.length > 0
                ? (clearFrameMaterial.classList.add("active"),
                  (document.getElementById(
                    "filter-count-frame-material",
                  ).innerHTML =
                    `(${initialStateFilter.framematerialCollection.length})`),
                  document
                    .getElementById("filter-count-frame-material")
                    .classList.add("active"))
                : (clearFrameMaterial.classList.remove("active"),
                  (document.getElementById(
                    "filter-count-frame-material",
                  ).innerHTML = ""),
                  document
                    .getElementById("filter-count-frame-material")
                    .classList.remove("active"));
            }
          });
        }),
        clearDimensions &&
          clearDimensions.addEventListener("click", () => {
            (clearDimensions.classList.remove("active"),
              (document.getElementById("filter-count-dimensions").innerHTML = ""),
              document
                .getElementById("filter-count-dimensions")
                .classList.remove("active"),
              (initialStateFilter.dimensionsCount = []));
            var frameWidthSlider = document.getElementById("frame-width-slider");
            (frameWidthSlider?.noUiSlider.reset(),
              (initialStateFilter.frameWidth = []));
            var bridgeWidthSlider = document.getElementById(
              "bridge-width-slider",
            );
            (bridgeWidthSlider?.noUiSlider.reset(),
              (initialStateFilter.bridgeWidth = []));
            var templeWidthSlider = document.getElementById("temple-length-slider"); // FIX: was "temple-width-slider"
            (templeWidthSlider?.noUiSlider.reset(),
              (initialStateFilter.templeWidth = []));
            var lensWidthSlider = document.getElementById("lens-width-slider");
            (lensWidthSlider?.noUiSlider.reset(),
              (initialStateFilter.lensWidth = []));
            var lensHeightSlider = document.getElementById("lens-height-slider");
            (lensHeightSlider?.noUiSlider.reset(),
              (initialStateFilter.lensHeight = []),
              (initialStateFilter.frameWidthChanged = !1),
              (initialStateFilter.bridgeWidthChanged = !1),
              (initialStateFilter.templeWidthChanged = !1),
              (initialStateFilter.lensHeightChanged = !1),
              (initialStateFilter.lensWidthChanged = !1),
              document
                .querySelectorAll('.selected-filter[data-target="frameWidth"]')
                .forEach((el) => el.remove()),
              document
                .querySelectorAll('.selected-filter[data-target="templeWidth"]')
                .forEach((el) => el.remove()),
              document
                .querySelectorAll('.selected-filter[data-target="lensWidth"]')
                .forEach((el) => el.remove()),
              document
                .querySelectorAll('.selected-filter[data-target="lensHeight"]')
                .forEach((el) => el.remove()),
              document
                .querySelectorAll('.selected-filter[data-target="bridgeWidth"]')
                .forEach((el) => el.remove()),
              document.querySelectorAll(".selected-filter").length == 0 &&
                $("#filter-result-flex").removeClass("active"),
              applyInstantFilter());
          })));
  }
  function handleFacetsCollapse() {
    const tabHeading = document.querySelectorAll(
      ".tab-item-facet .tab-heading-facet",
    );
    tabHeading &&
      tabHeading.forEach((tab) => {
        tab.addEventListener("click", () => {
          tab.parentNode.classList.toggle("is-active");
        });
      });
  }
  function applyFilter(
    regenerateFacets = !1,
    page = 1,
    loadmore = !1,
    hidefilter = !0,
    loadingWithParams = !1,
  ) {
    hidefilter && hideFilter();
    const availabilityFilter =
        initialStateFilter.availabilityCollection.join("|"),
      finishFilter = initialStateFilter.finishCollection.join("|"),
      materialFilter = initialStateFilter.framematerialCollection.join("|"),
      frameColors = initialStateFilter.frameColorCollection.join("|"),
      lensColors = initialStateFilter.lensColorCollection.join("|"),
      sizes = initialStateFilter.frameSizeCollection.join("|"),
      tints = initialStateFilter.lensTintCollection.join("|"),
      tagsFilters = [];
    (availabilityFilter.length > 0 && tagsFilters.push(availabilityFilter),
      finishFilter.length > 0 && tagsFilters.push(finishFilter),
      materialFilter.length > 0 && tagsFilters.push(materialFilter),
      frameColors.length > 0 && tagsFilters.push(frameColors),
      lensColors.length > 0 && tagsFilters.push(lensColors),
      sizes.length > 0 && tagsFilters.push(sizes),
      tints.length > 0 && tagsFilters.push(tints));

    initialStateFilter.frameWidthChanged &&
      applyNumericSliderFilter({
        sliderId: "frame-width-slider",
        options: frameWidthOptions,
        stateKey: "frameWidth",
        tagPrefix: "frame_width-",
        decimals: 1,
      });
    initialStateFilter.bridgeWidthChanged &&
      applyNumericSliderFilter({
        sliderId: "bridge-width-slider",
        options: bridgeWidthOptions,
        stateKey: "bridgeWidth",
        tagPrefix: "bridge_width-",
        decimals: 1,
      });
    initialStateFilter.templeWidthChanged &&
      applyNumericSliderFilter({
        sliderId: "temple-length-slider",
        options: templeWidthOptions,
        stateKey: "templeWidth",
        tagPrefix: "temple_length-",
        decimals: 1,
      });
    initialStateFilter.lensWidthChanged &&
      applyNumericSliderFilter({
        sliderId: "lens-width-slider",
        options: lensWidthOptions,
        stateKey: "lensWidth",
        tagPrefix: "lens_width-",
        decimals: 1,
      });
    initialStateFilter.lensHeightChanged &&
      applyNumericSliderFilter({
        sliderId: "lens-height-slider",
        options: lensHeightOptions,
        stateKey: "lensHeight",
        tagPrefix: "lens_height-",
        decimals: 1,
      });
    initialStateFilter.lensTransmissionChanged &&
      applyNumericSliderFilter({
        sliderId: "lens-transmission-slider",
        options: lensTransmissionOptions,
        stateKey: "lensTransmission",
        tagPrefix: "lens_light_trans-",
        decimals: 2,
      });

    initialStateFilter.frameWidth.length > 0 &&
      tagsFilters.push(initialStateFilter.frameWidth.join("|"));
    initialStateFilter.bridgeWidth.length > 0 &&
      tagsFilters.push(initialStateFilter.bridgeWidth.join("|"));
    initialStateFilter.templeWidth.length > 0 &&
      tagsFilters.push(initialStateFilter.templeWidth.join("|"));
    initialStateFilter.lensWidth.length > 0 &&
      tagsFilters.push(initialStateFilter.lensWidth.join("|"));
    initialStateFilter.lensHeight.length > 0 &&
      tagsFilters.push(initialStateFilter.lensHeight.join("|"));
    initialStateFilter.lensTransmission.length > 0 &&
      tagsFilters.push(initialStateFilter.lensTransmission.join("|"));

    const filterBy = tagsFilters.join(","),
      minPrice = document.getElementById("fromInput")
        ? parseInt(document.getElementById("fromInput").value)
        : 0,
      maxPrice = document.getElementById("toInput")
        ? parseInt(document.getElementById("toInput").value)
        : 0;
    let filterByPrice = minPrice + "," + maxPrice;
    ((minPrice === 0 || maxPrice === 0) && (filterByPrice = null),
      search(
        filterBy,
        filterByPrice,
        page,
        regenerateFacets,
        loadmore,
        !1,
        !1,
        loadingWithParams,
      ));
  }
  function hideFilter() {
    $(".collection__main").removeClass("filter-open");
  }
  function createLoadingState() {
    const loadingState = document.createElement("div");
    ((loadingState.className = "filter-loading"),
      loadingState.setAttribute("id", "filter-loading"),
      (loadingState.innerHTML = "<span></span>"),
      document.body.appendChild(loadingState),
      (loadingState.style.display = "flex"));
  }
  function addAppendedProductsToCart() {
    document
      .querySelectorAll(".collection-add-to-cart")
      .forEach((addToCartBtn) => {
        addToCartBtn.addEventListener("click", (event) => {
          (event.preventDefault(), (event.target.innerHTML = "Adding"));
          let pId = event.target.getAttribute("product-id");
          fetch("/cart/add.js", {
            body: JSON.stringify({
              id: pId,
              quantity: 1,
              sections: ["cart-drawer", "header-classic"],
            }),
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "xmlhttprequest",
            },
            method: "POST",
          })
            .then((res) => res.json())
            .then((res) => {
              ((event.target.innerHTML = "Added"),
                $("#shopify-section-cart-drawer .section_holder").html(
                  $(res.sections["cart-drawer"]).find(".section_holder").html(),
                ));
              const bubble = new DOMParser()
                .parseFromString(res.sections["header-classic"], "text/html")
                .querySelector(".header-cart__count").innerHTML;
              (document
                .querySelectorAll(".header-cart__count")
                .forEach((element) => {
                  ((element.innerHTML = bubble),
                    +bubble > 0 ? $(element).show() : $(element).hide());
                }),
                open_slider_cart());
            });
        });
      });
  }
  const closeFilterSideBar = () => {
    $(".collection__main").removeClass("filter-open");
  };

  document.querySelector(".filter-button")?.addEventListener("click", () => {
    setTimeout(() => scheduleSliderReinit(3, 120), 50);
  });
  function applyInstantFilter(populateFiltersOnly = !1) {
    populateFiltersOnly || $(".sidebar-content").addClass("filtering");
    const openedFacets = document.querySelectorAll(".tab-item-facet.is-active");
    ((initialStateFilter.openedFacets = []),
      openedFacets.length &&
        openedFacets.forEach((facet) => {
          initialStateFilter.openedFacets.push(facet.dataset.facet);
        }));
    const selectedFilters = document.getElementById("selected-filters");
    if (
      (populateFiltersOnly || applyFilter(!0, 1, !1, !1),
      initialStateFilter.availabilityCollection.length > 0 ||
        initialStateFilter.finishCollection.length > 0 ||
        initialStateFilter.frameColorCollection.length > 0 ||
        initialStateFilter.lensColorCollection.length > 0 ||
        initialStateFilter.framematerialCollection.length > 0 ||
        initialStateFilter.frameWidth.length > 0 ||
        initialStateFilter.bridgeWidth.length > 0 ||
        initialStateFilter.templeWidth.length > 0 ||
        initialStateFilter.lensWidth.length > 0 ||
        initialStateFilter.lensHeight.length > 0 ||
        initialStateFilter.lensTransmission.length > 0 ||
        initialStateFilter.frameSizeCollection.length > 0 ||
        initialStateFilter.lensTintCollection.length > 0)
    ) {
      (document.getElementById("filter-result-flex").classList.add("active"),
        (selectedFilters.innerHTML = ""));
      const frameColorCollection = initialStateFilter.frameColorCollection.reduce(
          (content, values) =>
            content +
            `<span data-value="${values}" data-target="frameColorCollection" class="selected-filter">${values.replaceAll("-", " ").replaceAll("_", " ")} <span>x</span></span>`,
          "",
        ),
        lensColorCollection = initialStateFilter.lensColorCollection.reduce(
          (content, values) =>
            content +
            `<span data-value="${values}" data-target="lensColorCollection" class="selected-filter">${values.replaceAll("-", " ").replaceAll("_", " ")} <span>x</span></span>`,
          "",
        ),
        availabilityCollection = initialStateFilter.availabilityCollection.reduce(
          (content, values) =>
            content +
            `<span data-value="${values}" data-target="availabilityCollection" class="selected-filter">${values.replaceAll("-", " ")} <span>x</span></span>`,
          "",
        ),
        finishCollection = initialStateFilter.finishCollection.reduce(
          (content, values) =>
            content +
            `<span data-value="${values}" data-target="finishCollection" class="selected-filter">${values.replaceAll("-", " ")} <span>x</span></span>`,
          "",
        ),
        framematerialCollection =
          initialStateFilter.framematerialCollection.reduce(
            (content, values) =>
              content +
              `<span data-value="${values}" data-target="framematerialCollection" class="selected-filter">${values.replaceAll("-", " ")} <span>x</span></span>`,
            "",
          ),
        frameSizeCollection = initialStateFilter.frameSizeCollection.reduce(
          (content, values) =>
            content +
            `<span data-value="${values}" data-target="frameSizeCollection" class="selected-filter">${values.replaceAll("_", " ").replaceAll("-", " ")} <span>x</span></span>`,
          "",
        ),
        lensTintCollection = initialStateFilter.lensTintCollection.reduce(
          (content, values) =>
            content +
            `<span data-value="${values}" data-target="lensTintCollection" class="selected-filter">${values.replaceAll("_", " ").replaceAll("-", " ")} <span>x</span></span>`,
          "",
        ),
        frameWidthCollection =
          initialStateFilter.frameWidth.length > 0
            ? `<span class="selected-filter" data-target="frameWidth">frame width: ${initialStateFilter.frameWidth.reduce((content, values) => content + values.replace("frame_width-", " - ")).replace("frame_width-", "")} <span>x</span></span>`
            : "";
      setTimeout(() => {
        if (document.querySelector(".selected-filter[data-target=frameWidth]")) {
          const frameWidth = document.querySelector(
            ".selected-filter[data-target=frameWidth]",
          );
          frameWidth.innerHTML =
            (
              frameWidth.textContent.split("-")[0] +
              "-" +
              frameWidth.textContent.split("-")[
                frameWidth.textContent.split("-").length - 1
              ]
            ).replace("x", "") + "<span>x</span>";
        }
      }, 10);
      const bridgeWidthCollection =
        initialStateFilter.bridgeWidth.length > 0
          ? `<span class="selected-filter" data-target="bridgeWidth">bridge width: ${initialStateFilter.bridgeWidth.reduce((content, values) => content + values.replace("bridge_width-", " - ")).replace("bridge_width-", "")} <span>x</span></span>`
          : "";
      setTimeout(() => {
        if (document.querySelector(".selected-filter[data-target=bridgeWidth]")) {
          const bridgeWidth = document.querySelector(
            ".selected-filter[data-target=bridgeWidth]",
          );
          bridgeWidth.innerHTML =
            (
              bridgeWidth.textContent.split("-")[0] +
              "-" +
              bridgeWidth.textContent.split("-")[
                bridgeWidth.textContent.split("-").length - 1
              ]
            ).replace("x", "") + "<span>x</span>";
        }
      }, 10);
      const templeWidthCollection =
        initialStateFilter.templeWidth.length > 0
          ? `<span class="selected-filter" data-target="templeWidth">temple length: ${initialStateFilter.templeWidth.reduce((content, values) => content + values.replace("temple_length-", " - ")).replace("temple_length-", "")} <span>x</span></span>`
          : "";
      setTimeout(() => {
        if (document.querySelector(".selected-filter[data-target=templeWidth]")) {
          const templeWidth = document.querySelector(
            ".selected-filter[data-target=templeWidth]",
          );
          templeWidth.innerHTML =
            (
              templeWidth.textContent.split("-")[0] +
              "-" +
              templeWidth.textContent.split("-")[
                templeWidth.textContent.split("-").length - 1
              ]
            ).replace("x", "") + "<span>x</span>";
        }
      }, 10);
      const lensWidthCollection =
        initialStateFilter.lensWidth.length > 0
          ? `<span class="selected-filter" data-target="lensWidth">lens width: ${initialStateFilter.lensWidth.reduce((content, values) => content + values.replace("lens_width-", " - ")).replace("lens_width-", "")} <span>x</span></span>`
          : "";
      setTimeout(() => {
        if (document.querySelector(".selected-filter[data-target=lensWidth]")) {
          const lensWidth = document.querySelector(
            ".selected-filter[data-target=lensWidth]",
          );
          lensWidth.innerHTML =
            (
              lensWidth.textContent.split("-")[0] +
              "-" +
              lensWidth.textContent.split("-")[
                lensWidth.textContent.split("-").length - 1
              ]
            ).replace("x", "") + "<span>x</span>";
        }
      }, 10);
      const lensHeightCollection =
        initialStateFilter.lensHeight.length > 0
          ? `<span class="selected-filter" data-target="lensHeight">lens height: ${initialStateFilter.lensHeight.reduce((content, values) => content + values.replace("lens_height-", " - ")).replace("lens_height-", "")} <span>x</span></span>`
          : "";
      setTimeout(() => {
        if (document.querySelector(".selected-filter[data-target=lensHeight]")) {
          const lensHeight = document.querySelector(
            ".selected-filter[data-target=lensHeight]",
          );
          lensHeight.innerHTML =
            (
              lensHeight.textContent.split("-")[0] +
              "-" +
              lensHeight.textContent.split("-")[
                lensHeight.textContent.split("-").length - 1
              ]
            ).replace("x", "") + "<span>x</span>";
        }
      }, 10);
      const lensTransmissionCollection =
        initialStateFilter.lensTransmission.length > 0
          ? `<span class="selected-filter" data-target="lensTransmission">lens transmission: ${initialStateFilter.lensTransmission.reduce((content, values) => content + values.replace("lens_light_trans-", " - ")).replace("lens_light_trans-", "")} <span>x</span></span>`
          : "";
      (setTimeout(() => {
        if (
          document.querySelector(".selected-filter[data-target=lensTransmission]")
        ) {
          const lensTransmission = document.querySelector(
            ".selected-filter[data-target=lensTransmission]",
          );
          lensTransmission.innerHTML =
            (
              lensTransmission.textContent.split("-")[0] +
              "-" +
              lensTransmission.textContent.split("-")[
                lensTransmission.textContent.split("-").length - 1
              ]
            ).replace("x", "") + "<span>x</span>";
        }
      }, 10),
        (selectedFilters.innerHTML +=
          lensColorCollection +
          frameColorCollection +
          availabilityCollection +
          finishCollection +
          framematerialCollection +
          frameWidthCollection +
          frameSizeCollection +
          lensTintCollection +
          lensTransmissionCollection +
          bridgeWidthCollection +
          templeWidthCollection +
          lensWidthCollection +
          lensHeightCollection));
    }
    initialStateFilter.availabilityCollection.length === 0 &&
      initialStateFilter.finishCollection.length === 0 &&
      initialStateFilter.frameColorCollection.length === 0 &&
      initialStateFilter.lensColorCollection.length === 0 &&
      initialStateFilter.framematerialCollection.length === 0 &&
      initialStateFilter.frameWidth.length === 0 &&
      initialStateFilter.bridgeWidth.length === 0 &&
      initialStateFilter.templeWidth.length === 0 &&
      initialStateFilter.lensWidth.length === 0 &&
      initialStateFilter.lensHeight.length === 0 &&
      initialStateFilter.lensTransmission.length === 0 &&
      initialStateFilter.frameSizeCollection.length === 0 &&
      initialStateFilter.lensTintCollection.length === 0 &&
      document.getElementById("filter-result-flex").classList.remove("active");
    const appliedFilters = document.querySelectorAll(".selected-filter");
    appliedFilters.length > 0 &&
      appliedFilters.forEach((appliedFilter) => {
        appliedFilter.addEventListener("click", () => {
          if (
            (appliedFilter.remove(),
            document.getElementById("selected-filters").innerHTML === "" &&
              document
                .getElementById("filter-result-flex")
                .classList.remove("active"),
            appliedFilter.getAttribute("data-value"))
          ) {
            const dataValue = appliedFilter.getAttribute("data-value"),
              [key, value] = splitAtLastDash(dataValue);
            key &&
              value &&
              Object.values(initialStateFilter.urlParamKeys).includes(key) &&
              replaceUrlParam(key, value, !0);
            const index = initialStateFilter[
              appliedFilter.getAttribute("data-target")
            ].indexOf(appliedFilter.getAttribute("data-value"));
            if (
              (initialStateFilter[
                appliedFilter.getAttribute("data-target")
              ].splice(index, 1),
              checkSelectedOptions(),
              document.getElementById(
                `${appliedFilter.getAttribute("data-value")}`,
              ) &&
                (document.getElementById(
                  `${appliedFilter.getAttribute("data-value")}`,
                ).checked = !1),
              appliedFilter.getAttribute("data-target") ===
                "frameColorCollection")
            ) {
              let frameColorLength = [];
              (initialStateFilter.frameColorCollection.forEach((item) => {
                frameColorLength.push(item);
              }),
                frameColorLength.length > 0
                  ? (document.getElementById(
                      "filter-count-frame-color",
                    ).innerHTML = `(${frameColorLength.length})`)
                  : ((document.getElementById(
                      "filter-count-frame-color",
                    ).innerHTML = ""),
                    document
                      .getElementById("clear-filter-frame-color")
                      .classList.remove("active")));
            }
            if (
              appliedFilter.getAttribute("data-target") === "lensColorCollection"
            ) {
              let lensColorLength = [];
              (initialStateFilter.lensColorCollection.forEach((item) => {
                lensColorLength.push(item);
              }),
                lensColorLength.length > 0
                  ? (document.getElementById(
                      "filter-count-lens-color",
                    ).innerHTML = `(${lensColorLength.length})`)
                  : ((document.getElementById(
                      "filter-count-lens-color",
                    ).innerHTML = ""),
                    document
                      .getElementById("clear-filter-lens-color")
                      .classList.remove("active")));
            }
            (appliedFilter.getAttribute("data-target") === "finishCollection" &&
              (initialStateFilter[appliedFilter.getAttribute("data-target")]
                .length > 0
                ? (document.getElementById("filter-count-finish").innerHTML =
                    `(${initialStateFilter[appliedFilter.getAttribute("data-target")].length})`)
                : ((document.getElementById("filter-count-finish").innerHTML =
                    ""),
                  document
                    .getElementById("clear-filter-finish")
                    .classList.remove("active"))),
              appliedFilter.getAttribute("data-target") ===
                "framematerialCollection" &&
                (initialStateFilter[appliedFilter.getAttribute("data-target")]
                  .length > 0
                  ? (document.getElementById(
                      "filter-count-frame-material",
                    ).innerHTML =
                      `(${initialStateFilter[appliedFilter.getAttribute("data-target")].length})`)
                  : ((document.getElementById(
                      "filter-count-frame-material",
                    ).innerHTML = ""),
                    document
                      .getElementById("clear-filter-frame-material")
                      .classList.remove("active"))),
              appliedFilter.getAttribute("data-target") ===
                "frameSizeCollection" &&
                (initialStateFilter[appliedFilter.getAttribute("data-target")]
                  .length > 0
                  ? (document.getElementById(
                      "filter-count-frame-size",
                    ).innerHTML =
                      `(${initialStateFilter[appliedFilter.getAttribute("data-target")].length})`)
                  : ((document.getElementById(
                      "filter-count-frame-size",
                    ).innerHTML = ""),
                    document
                      .getElementById("clear-filter-frame-size")
                      .classList.remove("active"))),
              appliedFilter.getAttribute("data-target") ===
                "lensTintCollection" &&
                (initialStateFilter[appliedFilter.getAttribute("data-target")]
                  .length > 0
                  ? (document.getElementById("filter-count-lens-tint").innerHTML =
                      `(${initialStateFilter[appliedFilter.getAttribute("data-target")].length})`)
                  : ((document.getElementById(
                      "filter-count-lens-tint",
                    ).innerHTML = ""),
                    document
                      .getElementById("clear-filter-lens-tint")
                      .classList.remove("active"))));
          } else {
            if (appliedFilter.getAttribute("data-target") === "frameWidth") {
              var frameWidthSlider =
                document.getElementById("frame-width-slider");
              (frameWidthSlider?.noUiSlider.reset(),
                (initialStateFilter.frameWidth = []),
                (initialStateFilter.frameWidthChanged = !1),
                initialStateFilter.dimensionsCount.includes("frame") &&
                  (initialStateFilter.dimensionsCount.splice(
                    initialStateFilter.dimensionsCount.indexOf("frame"),
                    1,
                  ),
                  (document.getElementById("filter-count-dimensions").innerHTML =
                    "(" + initialStateFilter.dimensionsCount.length + ")")),
                initialStateFilter.dimensionsCount.length === 0 &&
                  (document
                    .getElementById("clear-filter-dimensions")
                    .classList.remove("active"),
                  document
                    .getElementById("filter-count-dimensions")
                    .classList.remove("active")));
            }
            if (appliedFilter.getAttribute("data-target") === "bridgeWidth") {
              var bridgeWidthSlider = document.getElementById(
                "bridge-width-slider",
              );
              (bridgeWidthSlider?.noUiSlider.reset(),
                (initialStateFilter.bridgeWidth = []),
                (initialStateFilter.bridgeWidthChanged = !1),
                initialStateFilter.dimensionsCount.includes("bridge") &&
                  (initialStateFilter.dimensionsCount.splice(
                    initialStateFilter.dimensionsCount.indexOf("bridge"),
                    1,
                  ),
                  (document.getElementById("filter-count-dimensions").innerHTML =
                    "(" + initialStateFilter.dimensionsCount.length + ")")),
                initialStateFilter.dimensionsCount.length === 0 &&
                  (document
                    .getElementById("clear-filter-dimensions")
                    .classList.remove("active"),
                  document
                    .getElementById("filter-count-dimensions")
                    .classList.remove("active")));
            }
            if (appliedFilter.getAttribute("data-target") === "templeWidth") {
              var templeWidthSlider = document.getElementById("temple-length-slider"); // FIX: was "temple-width-slider"
              (templeWidthSlider?.noUiSlider.reset(),
                (initialStateFilter.templeWidth = []),
                (initialStateFilter.templeWidthChanged = !1),
                initialStateFilter.dimensionsCount.includes("temple") &&
                  (initialStateFilter.dimensionsCount.splice(
                    initialStateFilter.dimensionsCount.indexOf("temple"),
                    1,
                  ),
                  (document.getElementById("filter-count-dimensions").innerHTML =
                    "(" + initialStateFilter.dimensionsCount.length + ")")),
                initialStateFilter.dimensionsCount.length === 0 &&
                  (document
                    .getElementById("clear-filter-dimensions")
                    .classList.remove("active"),
                  document
                    .getElementById("filter-count-dimensions")
                    .classList.remove("active")));
            }
            if (appliedFilter.getAttribute("data-target") === "lensWidth") {
              var lensWidthSlider = document.getElementById("lens-width-slider");
              (lensWidthSlider?.noUiSlider.reset(),
                (initialStateFilter.lensWidth = []),
                (initialStateFilter.lensWidthChanged = !1),
                initialStateFilter.dimensionsCount.includes("lens") &&
                  (initialStateFilter.dimensionsCount.splice(
                    initialStateFilter.dimensionsCount.indexOf("lens"),
                    1,
                  ),
                  (document.getElementById("filter-count-dimensions").innerHTML =
                    "(" + initialStateFilter.dimensionsCount.length + ")")),
                initialStateFilter.dimensionsCount.length === 0 &&
                  (document
                    .getElementById("clear-filter-dimensions")
                    .classList.remove("active"),
                  document
                    .getElementById("filter-count-dimensions")
                    .classList.remove("active")));
            }
            if (appliedFilter.getAttribute("data-target") === "lensHeight") {
              var lensHeightSlider =
                document.getElementById("lens-height-slider");
              (lensHeightSlider?.noUiSlider.reset(),
                (initialStateFilter.lensHeight = []),
                (initialStateFilter.lensHeightChanged = !1),
                initialStateFilter.dimensionsCount.includes("lens-height") &&
                  (initialStateFilter.dimensionsCount.splice(
                    initialStateFilter.dimensionsCount.indexOf("lens-height"),
                    1,
                  ),
                  (document.getElementById("filter-count-dimensions").innerHTML =
                    "(" + initialStateFilter.dimensionsCount.length + ")")),
                initialStateFilter.dimensionsCount.length === 0 &&
                  (document
                    .getElementById("clear-filter-dimensions")
                    .classList.remove("active"),
                  document
                    .getElementById("filter-count-dimensions")
                    .classList.remove("active")));
            }
            if (
              appliedFilter.getAttribute("data-target") === "lensTransmission"
            ) {
              var lensTransmissionSlider = document.getElementById(
                "lens-transmission-slider",
              );
              (lensTransmissionSlider?.noUiSlider.reset(),
                (initialStateFilter.lensTransmission = []),
                (initialStateFilter.lensTransmissionChanged = !1),
                document.getElementById("clear-filter-lens-transmission") &&
                  document
                    .getElementById("clear-filter-lens-transmission")
                    .classList.remove("active"),
                document.getElementById("filter-count-lens-transmission") &&
                  ((document.getElementById(
                    "filter-count-lens-transmission",
                  ).innerHTML = ""),
                  document
                    .getElementById("filter-count-lens-transmission")
                    .classList.remove("active")));
            }
          }
          applyInstantFilter();
        });
      });
  }
  const replaceUrlParam = (key, value, remove = !1) => {
    const url = new URL(window.location.href),
      params = new URLSearchParams(url.search),
      newValueArray = (params.get(key) || "")
        .split(",")
        .filter(
          (v) =>
            v.toLowerCase().trim() !== value.toLowerCase().trim() &&
            v.toLowerCase().trim(),
        );
    remove || newValueArray.push(value.toLowerCase().trim());
    const newValue = newValueArray.join(",");
    (!newValue || !value ? params.delete(key) : params.set(key, newValue),
      (url.search = params.toString()),
      history.pushState({}, "", url.toString()));
  };
  function splitAtLastDash(str) {
    const lastDashIndex = str.lastIndexOf("-");
    return lastDashIndex === -1
      ? [str]
      : [str.slice(0, lastDashIndex), str.slice(lastDashIndex + 1)];
  }
